


import $ from 'jquery';
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
jQueryBridget('isotope', Isotope, $);

// scoped variables
var animationSpeed = 300;
var $grid;

export default function productFilter() {
    if ($('.grid-item').length > 0) {
        $grid = $('.grid').isotope({
            itemSelector: '.grid-item'
        });
    }

    // shows and hides filtered items
    $(".filter-simple-button").click(function (e) {
        e.preventDefault();
        var value = $(this).attr('data-filter');
        if (value === "all") {
            $grid.isotope({ filter: '*' });
        } else {

            $grid.isotope({ filter: '.' + value });
        }
    });

    // changes active class on filter buttons
    $('.filter-simple-button').click(function () {
        $(this).siblings().removeClass('is-active');
        $(this).addClass('is-active');
    });

    // changes colour on every second tile in tile hub
    //$(".tileGrid--tile").filter(function (index, element) {
    //    return index % 2;
    //}).addClass("tileGrid--tileAlt");

    var qs = getUrlVars();
    if (qs.filter) {
        $("[data-filter*='" + decodeURI(qs.filter) + "' i]").trigger("click");
    }

    if ($(".filter-simple-button").length) {
        $(".filter-simple-button:first").click();

    }
}

   

function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

